var map = {
	"./about_banner.webp": 74394,
	"./about_img1.png": 79381,
	"./about_img2.png": 93630,
	"./about_img3.png": 46119,
	"./about_img4.png": 66504,
	"./about_img5.png": 60369,
	"./about_img6.png": 55610,
	"./about_mascot.webp": 20587
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52127;